/**
=========================================================
* Soft UI Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from 'react';

// Custom styles for SuiButton
import SuiLoadingButtonRoot from './SuiLoadingButtonRoot';

const SuiLoadingButton = forwardRef(
    ({ color, variant, size, circular, iconOnly, children, ...rest }, ref) => (
        <SuiLoadingButtonRoot
            {...rest}
            ref={ref}
            color="primary"
            variant={variant}
            size={size}
            ownerState={{ color, variant, size, circular, iconOnly }}
        >
            {/* Wrapping to <div> to prevent app crash when using Automatic translation: https://github.com/mui/material-ui/issues/27853 */}
            <div style={{ display: 'contents' }}>{children}</div>
        </SuiLoadingButtonRoot>
    ),
);

// Setting default values for the props of SuiButton
SuiLoadingButton.defaultProps = {
    size: 'medium',
    variant: 'contained',
    color: 'white',
    circular: false,
    iconOnly: false,
};

export default SuiLoadingButton;
